export default "__VITE_ASSET__D$X6E1dv__"